import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../Assets/Image/sidebar/e-logo.png";
import dash from "../../Assets/Image/sidebar/dashboard.png";
import dash1 from "../../Assets/Image/sidebar/dashboard1.png";
import Dialog from "../../Base-Component/Dialog/Dialog";
import { Bell, ClipboardMinus, Dumbbell, Image, Users } from "lucide-react";

const SideMenu = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const trigger = useRef(null);
  const sidebar = useRef(null);

  const [isLogOut, setIsLogOut] = useState(false);

  const storedSidebarExpanded = localStorage.getItem("sidebar-expanded");
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === "true"
  );

  const [adminData, setAdminData] = useState({});

  useEffect(() => {
    const admin = JSON.parse(localStorage.getItem("Admin"));
    if (admin) {
      setAdminData(admin);
    }
  }, []);

  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  useEffect(() => {
    localStorage.setItem("sidebar-expanded", sidebarExpanded.toString());
    if (sidebarExpanded) {
      document.querySelector("body")?.classList.add("sidebar-expanded");
    } else {
      document.querySelector("body")?.classList.remove("sidebar-expanded");
    }
  }, [sidebarExpanded]);

  return (
    <>
      <aside
        ref={sidebar}
        className={`absolute left-0 top-0 z-99 flex h-screen w-67 flex-col overflow-y-hidden duration-300 ease-linear dark:bg-boxdark 2xl:static xl:static lg:static 2xl:translate-x-0 xl:translate-x-0 lg:translate-x-0 ${sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        style={{ backgroundColor: "#fff" }}
      >
        {/* <!-- SIDEBAR HEADER --> */}
        <div className="flex items-center justify-center">
          <div
            onClick={() => {
              navigate("");
            }}
            className="py-3 mt-[17px] ms-4"
          >
            <img src={logo} className="w-[180px]" alt="" />
          </div>
          <div className="ms-8">
            <button
              ref={trigger}
              onClick={() => setSidebarOpen(!sidebarOpen)}
              aria-controls="sidebar"
              aria-expanded={sidebarOpen}
              className="lg:hidden block"
            >
              <svg
                className="fill-current"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 8.175H2.98748L9.36248 1.6875C9.69998 1.35 9.69998 0.825 9.36248 0.4875C9.02498 0.15 8.49998 0.15 8.16248 0.4875L0.399976 8.3625C0.0624756 8.7 0.0624756 9.225 0.399976 9.5625L8.16248 17.4375C8.31248 17.5875 8.53748 17.7 8.76248 17.7C8.98748 17.7 9.17498 17.625 9.36248 17.475C9.69998 17.1375 9.69998 16.6125 9.36248 16.275L3.02498 9.8625H19C19.45 9.8625 19.825 9.4875 19.825 9.0375C19.825 8.55 19.45 8.175 19 8.175Z"
                  fill=""
                />
              </svg>
            </button>
          </div>
        </div>
        {/* <!-- SIDEBAR HEADER --> */}

        <div className="no-scrollbar flex flex-col justify-between overflow-y-auto duration-300 ease-linear h-full px-10 py-3">
          <div className="flex justify-start">
            <div>
              <Link
                to={"/dashboard"}
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                <span
                  className={
                    location.pathname == "/dashboard"
                      ? "flex items-center bg-primary w-48 py-3 px-4 rounded-xl my-5"
                      : "my-5 flex items-center w-48 py-3 px-4"
                  }
                >
                  <img
                    src={location.pathname == "/dashboard" ? dash1 : dash}
                    className="w-6"
                    alt=""
                  />
                  <h4
                    className={
                      location.pathname == "/dashboard"
                        ? "text-[#fff] ms-3 fontNew font-medium"
                        : "text-[#4B4B4B] ms-3 fontNew font-medium"
                    }
                  >
                    Dashboard
                  </h4>
                </span>
              </Link>
              <Link to={"/users"} onClick={() => setSidebarOpen(!sidebarOpen)}>
                <span
                  className={
                    location.pathname.startsWith("/users") || location.pathname.startsWith("/user_details")
                      ? "flex items-center bg-primary w-48 py-3 px-4 rounded-xl my-5"
                      : "my-5 flex items-center w-48 py-3 px-4"
                  }
                >
                  <Users
                    color={
                      location.pathname.startsWith("/users") || location.pathname.startsWith("/user_details")
                        ? "white"
                        : "#4B4B4B"
                    }
                    size={24}
                  />
                  <h4
                    className={
                      location.pathname.startsWith("/users") || location.pathname.startsWith("/user_details")
                        ? "text-[#fff] ms-3 fontNew font-medium"
                        : "text-[#4B4B4B] ms-3 fontNew font-medium"
                    }
                  >
                    Users
                  </h4>
                </span>
              </Link>

              <Link to={"/all_post"} onClick={() => setSidebarOpen(!sidebarOpen)}>
                <span
                  className={
                    location.pathname == "/all_post"
                      ? "flex items-center bg-primary w-48 py-3 px-4 rounded-xl my-5"
                      : "my-5 flex items-center w-48 py-3 px-4"
                  }
                >
                  <Image
                    color={
                      location.pathname == "/all_post"
                        ? "white"
                        : "#4B4B4B"
                    }
                    size={24}
                  />
                  <h4
                    className={
                      location.pathname == "/all_post"
                        ? "text-[#fff] ms-3 fontNew font-medium"
                        : "text-[#4B4B4B] ms-3 fontNew font-medium"
                    }
                  >
                    All Post
                  </h4>
                </span>
              </Link>
              <Link to={"/excercise"} onClick={() => setSidebarOpen(!sidebarOpen)}>
                <span
                  className={
                    location.pathname == "/excercise"
                      ? "flex items-center bg-primary w-48 py-3 px-4 rounded-xl my-5"
                      : "my-5 flex items-center w-48 py-3 px-4"
                  }
                >
                  <Dumbbell
                    color={
                      location.pathname == "/excercise"
                        ? "white"
                        : "#4B4B4B"
                    }
                    size={24}
                  />
                  <h4
                    className={
                      location.pathname == "/excercise"
                        ? "text-[#fff] ms-3 fontNew font-medium"
                        : "text-[#4B4B4B] ms-3 fontNew font-medium"
                    }
                  >
                    Excercise
                  </h4>
                </span>
              </Link>
              <Link to={"/reports"} onClick={() => setSidebarOpen(!sidebarOpen)}>
                <span
                  className={
                    location.pathname == "/reports" || location.pathname.startsWith("/report_details")
                      ? "flex items-center bg-primary w-48 py-3 px-4 rounded-xl my-5"
                      : "my-5 flex items-center w-48 py-3 px-4" 
                  }
                >
                  <ClipboardMinus
                    color={
                      location.pathname == "/reports" || location.pathname.startsWith("/report_details")
                        ? "white"
                        : "#4B4B4B"
                    }
                    size={24}
                  />
                  <h4
                    className={
                      location.pathname == "/reports" || location.pathname.startsWith("/report_details")
                        ? "text-[#fff] ms-3 fontNew font-medium"
                        : "text-[#4B4B4B] ms-3 fontNew font-medium"
                    }
                  >
                    Reports
                  </h4>
                </span>
              </Link>
              <Link to={"/notification"} onClick={() => setSidebarOpen(!sidebarOpen)}>
                <span
                  className={
                    location.pathname == "/notification"
                      ? "flex items-center bg-primary w-48 py-3 px-4 rounded-xl my-5"
                      : "my-5 flex items-center w-48 py-3 px-4"
                  }
                >
                  <Bell
                    color={
                      location.pathname == "/notification"
                        ? "white"
                        : "#4B4B4B"
                    }
                    size={24}
                  />
                  <h4
                    className={
                      location.pathname == "/notification"
                        ? "text-[#fff] ms-3 fontNew font-medium"
                        : "text-[#4B4B4B] ms-3 fontNew font-medium"
                    }
                  >
                    Notification
                  </h4>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </aside>

      <Dialog open={isLogOut} onClose={() => setIsLogOut(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Log Out?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you certain you wish to proceed with <br /> logging out?
                </p>
                <div className="flex mt-13 mb-5">
                  <button
                    className="bg-[#F4F5FA] py-[14px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsLogOut(false)}
                  >
                    Close
                  </button>
                  <button
                    className="bg-primary py-[14px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={() => {
                      navigate("");
                    }}
                  >
                    Yes, Log Out
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </>
  );
};

export default SideMenu;
